import React from "react"
import Layout from "../components/core/layout"
import Post from "../components/post/post"
import SEO from "../components/Features/seo"
import Pager from "../components/Features/pager"
import { graphql } from "gatsby"
import slugify from "../utilty/utlityFunctions"
export default function CategoryPage({ data, pageContext }) {
  const { category } = pageContext
  const { totalCount } = data.allContentfulBlogPost
  const pageHeader = `${totalCount} post${
    totalCount === 1 ? "" : "s"
  } categorized with "${category}"`

  return (
    <Layout>
      <h1 className="jazz-feed text-left"> {pageHeader}</h1>
      <hr />
      {/* <p>{data.allContentfulBlogPost.edges.node.category[0].description}</p> */}
      <hr />
      {data.allContentfulBlogPost.edges.map(({ node }) => {
        return (
          <div key={node.title}>
            <Post post={node} />
            <SEO
              title={`${node.category[0].title} Category All Posts`}
              description={node.category[0].description}
              slug={slugify(node.category[0].title)}
            />
          </div>
        )
      })}
      <Pager pageContext={pageContext} />
    </Layout>
  )
}

export const CategoryPageQuery = graphql`
  query($category: String!, $skip: Int!, $limit: Int!) {
    allContentfulBlogPost(
      limit: $limit
      skip: $skip
      sort: { fields: [publishDate], order: DESC }
      filter: { category: { elemMatch: { title: { in: [$category] } } } }
    ) {
      totalCount
      edges {
        node {
          author {
            name
          }
          category {
            title
            description
          }
          title
          slug
          publishDate(formatString: "MMMM Do, YYYY")
          tags
          heroImage {
            fluid(maxWidth: 350, maxHeight: 196, resizingBehavior: SCALE) {
              ...GatsbyContentfulFluid
              base64
              # tracedSVG
              srcWebp
              srcSetWebp
            }
          }
          description {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
  }
`
